import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { Button } from "./ui/button";

const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const num = (n) => Number(n || 0).toLocaleString("id-ID");
const fmtStampFull = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}-${BULAN[d.getMonth()]}-${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
const fmtStamp = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getDate()}${BULAN[d.getMonth()]} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export default function VoucherPrint({ vouchers, profile, price, routerName, createdAt, open, onClose, mode = "thermal", showPrice = true }) {
  if (!open) return null;
  const isDesktop = mode === "desktop";
  // portal ke body: saat print, #root di-display:none — area cetak bebas dari layout aplikasi & ber-paginasi normal
  return createPortal(
    <div id="voucher-print-root" className="print-modal-root fixed inset-0 z-50 bg-black/70 backdrop-blur-md flex items-center justify-center p-6" data-testid="print-modal">
      <div className={`print-modal-card bg-card border border-border rounded-2xl w-full ${isDesktop ? "max-w-4xl" : "max-w-md"} max-h-[85vh] flex flex-col`}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-border flex-wrap gap-2">
          <h3 className="font-heading font-semibold">Pratinjau Cetak {isDesktop ? "Desktop" : "Thermal"} ({vouchers.length})</h3>
          <div className="flex items-center gap-2">
            <Button size="sm" onClick={() => window.print()} data-testid="btn-print-vouchers">Cetak</Button>
            <Button size="sm" variant="ghost" onClick={onClose} data-testid="btn-close-print"><X className="w-4 h-4" /></Button>
          </div>
        </div>
        <div className="print-modal-scroll overflow-y-auto p-4 bg-white rounded-b-2xl">
          {isDesktop ? (
            <div id="voucher-print-area" className="print-paginate print-desktop-grid mx-auto bg-white text-black grid grid-cols-5 gap-[2mm]" style={{ width: "200mm" }} data-testid="print-desktop-area">
              {vouchers.map((v, i) => (
                <div key={`${v.name}-${i}`} className="flex flex-col justify-between border border-neutral-500 rounded-sm px-[2mm] py-[1.5mm] leading-tight" style={{ breakInside: "avoid", height: "26.5mm" }} data-testid={`print-card-${v.name}`}>
                  <div className="text-[9px] font-bold uppercase tracking-wide">{routerName || "FASNET WIFI"}</div>
                  <div className="font-mono font-bold text-[24px] leading-none text-center tracking-wider">{v.name}</div>
                  <div className="flex justify-between text-[9.5px] font-semibold"><span>{profile || v.profile}{showPrice ? ` • Rp${num(price ?? v.price)}` : ""}</span><span className="font-normal">login: fas.net</span></div>
                  <div className="text-[7.5px] text-neutral-700">Cetak: {fmtStampFull(createdAt)} [{i + 1}]</div>
                </div>
              ))}
            </div>
          ) : (
            <div id="voucher-print-area" className="mx-auto bg-white text-black" style={{ width: "58mm" }} data-testid="print-thermal-area">
              {vouchers.map((v, i) => (
                <div key={`${v.name}-${i}`} className="px-2 py-2.5 text-center border-b border-dashed border-neutral-400" style={{ breakInside: "avoid" }} data-testid={`print-card-${v.name}`}>
                  <div className="text-[9px] font-bold uppercase tracking-wide">{routerName || "FASNET WIFI"}</div>
                  <div className="font-mono font-bold text-2xl leading-tight my-0.5">{v.name}</div>
                  <div className="text-[10px] font-semibold">{profile || v.profile}</div>
                  <div className="text-[9px] mt-0.5">Login: fas.net</div>
                  <div className="text-[8px] font-mono mt-1 text-neutral-600">{showPrice ? `Rp${num(price ?? v.price)} • ` : ""}{fmtStamp(createdAt)}[{i + 1}]</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
